import React from 'react'
import { TabMenu, TabMenuButton, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import CloseIcon from 'assets/icons/close'
import Files from './Files'
import General from './General'

const ScheduleSessionEdit = ({ onCloseButtonClick }) => {
   const match = useRouteMatch()

   return (
      <View>
         <View
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            padding="0px 18px"
            height="60px"
            borderBottom="1px solid #eee">
            <Text size="3" weight="medium">
               Edit Schedule Item
            </Text>
            <View
               marginLeft="18px"
               display="flex"
               justifyContent="flex-end"
               alignItems="center"
               onClick={onCloseButtonClick}>
               <CloseIcon width="24px" height="24px" />
            </View>
         </View>
         <View height="48px" backgroundColor="#f5f5f5">
            <TabMenu backgroundColor="#f5f5f5" paddingHorizontal="18px">
               <TabMenuButton linkExact linkTo={match.url} name="About" />
               <TabMenuButton linkTo={`${match.url}/files`} name="Files" />
            </TabMenu>
         </View>
         <View
            position="absolute"
            left="0px"
            right="0px"
            bottom="0px"
            top="108px"
            padding="18px"
            scroll="on">
            <Switch>
               <Route exact path={match.path} component={General} />
               <Route path={`${match.path}/files`} component={Files} />
            </Switch>
         </View>
      </View>
   )
}

ScheduleSessionEdit.propTypes = {
   onCloseButtonClick: PropTypes.func
}

ScheduleSessionEdit.defaultProps = {
   onCloseButtonClick: undefined
}

export default ScheduleSessionEdit
